import _ from 'lodash';
import { DESC_SIGN } from '../constants/table.constants';
import {
  resourceToTableState,
  resourceWithDataResetToTableState,
  tableQueryParamsSelector
} from '../selectors/resources.selectors';
import { apiActionCreator } from './api.actions';
import { fetchDone, fetchError, fetchReset, fetchStart } from './fetch.actions';
import { resourceAdd, resourceUpdate } from './resources.actions';

const FETCH_OPTIONS = ['sort', 'size'];

export function fetchForTable(resource, options = {}) {
  return (dispatch, getState) => {
    const config = tableQueryParamsSelector(getState(), { resource });
    const configWithOptions = {
      ...config,
      ..._.pick(options, FETCH_OPTIONS)
    };
    if (resource?.table?.disablePagination) {
      delete configWithOptions.size;
    }
    dispatch(fetchStart(resource));
    apiActionCreator(
      () => resource.api.get(configWithOptions),
      dispatch,
      (resp) => {
        const newState = resourceToTableState(resp, resource, getState());
        dispatch(resourceAdd(resource, newState));
        dispatch(fetchDone(resource));
      },
      {
        ...(options.errorHandlers ?? {}),
        all: (error) => {
          dispatch(fetchError(resource, error));
          const newState = resourceWithDataResetToTableState(resource, getState());
          dispatch(resourceAdd(resource, newState));
          options.errorHandlers?.all && options.errorHandlers?.all(error);
        }
      }
    );
  };
}

export function fetchForStaticTable(resource, data, options = {}) {
  return (dispatch, getState) => {
    const config = tableQueryParamsSelector(getState(), { resource });
    const configWithOptions = {
      ...config,
      ..._.pick(options, FETCH_OPTIONS)
    };
    if (resource?.table?.disablePagination) {
      delete configWithOptions.size;
    }
    dispatch(fetchStart(resource));
    const newData = { ...data };
    const ordered = _.orderBy(
      _.get(newData, resource?.table?.dataLocation, []),
      (x) => x[configWithOptions.sort?.replace('-', '')]?.toString?.()?.toLowerCase?.() ?? ''
    );
    const orderedWithDirection = configWithOptions?.sort?.[0] === DESC_SIGN ? ordered.reverse() : ordered;
    const paginated = resource?.table?.disablePagination
      ? orderedWithDirection
      : orderedWithDirection.slice(
          configWithOptions.size * configWithOptions.page - configWithOptions.size,
          configWithOptions.size * configWithOptions.page
        );
    _.set(newData, resource?.table?.dataLocation, paginated);
    const newState = resourceToTableState(newData, resource, getState());
    dispatch(resourceAdd(resource, newState));
    dispatch(fetchDone(resource));
  };
}

export function tableChange(resource, change) {
  return (dispatch) => {
    if (change?.page !== 0) {
      dispatch(resourceUpdate(resource, 'table', change));
      dispatch(fetchReset(resource));
    }
  };
}

export function selectedChange(resource, selected = []) {
  return (dispatch) => {
    dispatch(resourceUpdate(resource, 'selected', selected));
  };
}
